import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Safely convert any value to a renderable string.
 * Handles Pydantic v2 validation error arrays, nested detail objects, etc.
 */
export function safeString(value, fallback = '') {
  if (value == null) return fallback;
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) {
    const joined = value
      .map((item) => (typeof item === 'string' ? item : item?.msg || JSON.stringify(item)))
      .join('; ');
    return joined || fallback;
  }
  if (typeof value === 'object') {
    if (value.detail != null) return safeString(value.detail, fallback);
    if (typeof value.msg === 'string') return value.msg;
    if (typeof value.message === 'string') return value.message;
    return JSON.stringify(value);
  }
  return String(value);
}
